// src/i18n/orb-notation.json
var orb_notation_default = {
  reason: "Design-system token NAMES reachable only under a theme `tokens` node. They are keys of the .orb schema but notation, not language vocabulary, so they are excluded from the `orb` i18n section (owner ruling 2026-09-07). Regenerate with: pnpm --filter @almadar/core run gen:orb-notation",
  keys: [
    "2xl",
    "3xl",
    "4xl",
    "accent",
    "accentForeground",
    "background",
    "base",
    "bodyDefault",
    "bodyEmphasis",
    "bodyFamily",
    "bodyQuiet",
    "border",
    "borderHairline",
    "borderHeavy",
    "borderHover",
    "borderStandard",
    "buttonHeightLg",
    "buttonHeightMd",
    "buttonHeightSm",
    "caption",
    "card",
    "cardElevation",
    "cardForeground",
    "cardPaddingLg",
    "cardPaddingMd",
    "cardPaddingSm",
    "defaultSize",
    "dialogElevation",
    "dialogPadding",
    "display-1",
    "display-2",
    "displayFamily",
    "dramatic",
    "duration",
    "durations",
    "easing",
    "easings",
    "emphasized",
    "emptyAsset",
    "enter",
    "error",
    "errorAsset",
    "errorForeground",
    "exit",
    "expand",
    "family",
    "fast",
    "foreground",
    "headingMajor",
    "headingMinor",
    "hover",
    "info",
    "infoForeground",
    "input",
    "inputHeightLg",
    "inputHeightMd",
    "inputHeightSm",
    "instant",
    "intents",
    "lg",
    "lineHeight",
    "linear",
    "loadingAsset",
    "monoFamily",
    "muted",
    "mutedForeground",
    "normal",
    "numeric",
    "onboardingAsset",
    "placeholder",
    "popoverElevation",
    "press",
    "primary",
    "primaryForeground",
    "primaryHover",
    "radiusContainer",
    "radiusInteractive",
    "radiusPill",
    "ring",
    "rowHeightCompact",
    "rowHeightNormal",
    "rowHeightSpacious",
    "scale",
    "secondary",
    "secondaryForeground",
    "secondaryHover",
    "sectionGap",
    "size",
    "slot",
    "slow",
    "sm",
    "space0",
    "space1",
    "space10",
    "space11",
    "space12",
    "space2",
    "space3",
    "space4",
    "space5",
    "space6",
    "space7",
    "space8",
    "space9",
    "spring",
    "standard",
    "strokeWidth",
    "success",
    "successForeground",
    "surface",
    "surfaceHover",
    "tableBorder",
    "tableHeader",
    "tableRowHover",
    "toastElevation",
    "warning",
    "warningForeground",
    "weight",
    "xl",
    "xs"
  ]
};

// src/i18n/en.json
var en_default = {
  meta: {
    code: "en",
    name: "English",
    rtl: false
  },
  keywords: {
    app: "app",
    orbital: "orbital",
    uses: "uses",
    expects: "expects",
    entity: "entity",
    type: "type",
    derived: "derived",
    trait: "trait",
    initial: "initial",
    state: "state",
    for: "for",
    page: "page",
    as: "as",
    theme: "theme",
    emits: "emits",
    listens: "listens",
    ticks: "ticks",
    config: "config",
    when: "when",
    with: "with",
    from: "from",
    to: "to",
    every: "every",
    capabilities: "capabilities",
    match: "match",
    external: "external",
    internal: "internal",
    on: "on",
    name: "name",
    fields: "fields",
    events: "events",
    event: "event",
    emitsScope: "emitsScope",
    identity: "identity",
    pages: "pages",
    omit: "omit",
    only: "only",
    roles: "roles",
    entities: "entities",
    extend: "extend"
  },
  shapes: {
    Entity: "Entity",
    Trait: "Trait",
    Page: "Page",
    Orbital: "Orbital",
    Event: "Event"
  },
  tags: {
    persistent: "persistent",
    runtime: "runtime",
    shared: "shared",
    local: "local",
    identity: "identity",
    instance: "instance",
    collection: "collection"
  },
  categories: {
    interaction: "interaction",
    integration: "integration",
    lifecycle: "lifecycle",
    "game-core": "game-core",
    "game-entity": "game-entity",
    "game-ui": "game-ui"
  },
  capabilities: {
    read: "read",
    write: "write",
    browse: "browse",
    create: "create",
    update: "update",
    delete: "delete",
    notify: "notify",
    schedule: "schedule",
    invoke: "invoke"
  },
  annotations: {
    key: "key",
    unique: "unique",
    intrinsic: "intrinsic",
    label: "label",
    description: "description",
    synonyms: "synonyms",
    mock: "mock",
    tier: "tier",
    rebindable: "rebindable",
    read: "read",
    create: "create",
    update: "update",
    delete: "delete",
    icon: "icon"
  },
  sigils: {
    entity: "entity",
    payload: "payload",
    state: "state",
    now: "now",
    config: "config",
    user: "user",
    trait: "trait"
  },
  effects: {
    set: "set",
    fetch: "fetch",
    persist: "persist",
    emit: "emit",
    navigate: "navigate",
    "navigate-back": "navigate-back",
    "render-ui": "render-ui",
    notify: "notify",
    ref: "ref",
    "call-service": "call-service",
    invoke: "invoke",
    do: "do",
    if: "if",
    let: "let",
    fn: "fn",
    lambda: "lambda",
    match: "match",
    when: "when"
  },
  types: {
    string: "string",
    number: "number",
    int: "int",
    float: "float",
    bool: "bool",
    boolean: "boolean",
    timestamp: "timestamp",
    date: "date",
    datetime: "datetime",
    duration: "duration",
    money: "money",
    scalar: "scalar",
    file: "file",
    email: "email",
    url: "url",
    phone: "phone",
    uuid: "uuid",
    image: "image",
    icon: "icon",
    asset: "asset",
    component: "component",
    object: "object",
    array: "array",
    enum: "enum",
    relation: "relation",
    node: "node",
    union: "union",
    void: "void",
    null: "null",
    any: "any",
    trait: "trait",
    entity: "entity",
    event: "event",
    slot: "slot",
    pattern: "pattern",
    Map: "Map",
    secret: "secret",
    SExpr: "SExpr"
  },
  units: {
    ms: "ms",
    s: "s",
    m: "m",
    h: "h",
    d: "d"
  },
  literals: {
    true: "true",
    false: "false",
    null: "null"
  },
  reservedEvents: {
    INIT: "INIT"
  },
  orb: {
    _metadata: "_metadata",
    _resolved: "_resolved",
    access_waivers: "access_waivers",
    alias: "alias",
    animations: "animations",
    appliesTo: "appliesTo",
    as: "as",
    aspect: "aspect",
    assetRef: "assetRef",
    at: "at",
    auth: "auth",
    auxiliaryEntities: "auxiliaryEntities",
    bakedName: "bakedName",
    baseUrl: "baseUrl",
    behavior: "behavior",
    capabilities: "capabilities",
    cardinality: "cardinality",
    category: "category",
    className: "className",
    classification: "classification",
    collection: "collection",
    color: "color",
    colors: "colors",
    component: "component",
    config: "config",
    configProvenance: "configProvenance",
    container: "container",
    content: "content",
    create: "create",
    create_policy: "create_policy",
    createdAt: "createdAt",
    curName: "curName",
    customPatterns: "customPatterns",
    darkMode: "darkMode",
    dataEntities: "dataEntities",
    default: "default",
    definerKnob: "definerKnob",
    delayMs: "delayMs",
    delete: "delete",
    delete_policy: "delete_policy",
    density: "density",
    description: "description",
    description_visual_prompt: "description_visual_prompt",
    design: "design",
    designTokens: "designTokens",
    detailPattern: "detailPattern",
    device: "device",
    dimension: "dimension",
    domainContext: "domainContext",
    effectRow: "effectRow",
    effects: "effects",
    elevation: "elevation",
    emitIds: "emitIds",
    emits: "emits",
    emitsScope: "emitsScope",
    enabled: "enabled",
    entities: "entities",
    entity: "entity",
    entityBindingDescription: "entityBindingDescription",
    entityBindingSynonyms: "entityBindingSynonyms",
    entityContract: "entityContract",
    entityId: "entityId",
    entityRebindable: "entityRebindable",
    entityRefIds: "entityRefIds",
    entries: "entries",
    env: "env",
    equals: "equals",
    event: "event",
    eventId: "eventId",
    eventIds: "eventIds",
    events: "events",
    expects: "expects",
    exposes: "exposes",
    extend: "extend",
    extends: "extends",
    extendsId: "extendsId",
    field: "field",
    fields: "fields",
    flowPattern: "flowPattern",
    foreignKey: "foreignKey",
    formPattern: "formPattern",
    forwardedFrom: "forwardedFrom",
    from: "from",
    geometry: "geometry",
    guard: "guard",
    guards: "guards",
    headers: "headers",
    icon: "icon",
    iconography: "iconography",
    id: "id",
    identity: "identity",
    illustration: "illustration",
    inbound: "inbound",
    initialEffects: "initialEffects",
    instances: "instances",
    interactive: "interactive",
    interval: "interval",
    intrinsic: "intrinsic",
    isFinal: "isFinal",
    isInitial: "isInitial",
    isTerminal: "isTerminal",
    item: "item",
    items: "items",
    key: "key",
    keyName: "keyName",
    kind: "kind",
    knob: "knob",
    label: "label",
    ledger: "ledger",
    linkedEntity: "linkedEntity",
    linkedEntityId: "linkedEntityId",
    listPattern: "listPattern",
    listens: "listens",
    location: "location",
    max: "max",
    maxAttempts: "maxAttempts",
    mergedFrom: "mergedFrom",
    min: "min",
    mock: "mock",
    motion: "motion",
    mounts: "mounts",
    name: "name",
    omit: "omit",
    onDelete: "onDelete",
    onEntry: "onEntry",
    onExit: "onExit",
    only: "only",
    orbital: "orbital",
    orbitalId: "orbitalId",
    orbitals: "orbitals",
    originalEvent: "originalEvent",
    originalName: "originalName",
    outbound: "outbound",
    owner: "owner",
    pageIds: "pageIds",
    pages: "pages",
    parent: "parent",
    path: "path",
    pattern: "pattern",
    patternPath: "patternPath",
    payload: "payload",
    payloadEntity: "payloadEntity",
    payloadFor: "payloadFor",
    payloadMapping: "payloadMapping",
    payloadSchema: "payloadSchema",
    persistence: "persistence",
    personas: "personas",
    presentation: "presentation",
    primaryColor: "primaryColor",
    primaryEntity: "primaryEntity",
    primaryKey: "primaryKey",
    priority: "priority",
    prop: "prop",
    properties: "properties",
    props: "props",
    provides: "provides",
    radii: "radii",
    read: "read",
    read_policy: "read_policy",
    reconnect: "reconnect",
    ref: "ref",
    refId: "refId",
    reference: "reference",
    relatedLinks: "relatedLinks",
    relation: "relation",
    renames: "renames",
    request: "request",
    requestFragment: "requestFragment",
    required: "required",
    requiredFields: "requiredFields",
    requires: "requires",
    resolved: "resolved",
    resource: "resource",
    role: "role",
    roles: "roles",
    runtime: "runtime",
    schemaVersion: "schemaVersion",
    scope: "scope",
    scopeOverridden: "scopeOverridden",
    secretEnv: "secretEnv",
    sections: "sections",
    semanticRole: "semanticRole",
    serverPath: "serverPath",
    services: "services",
    shadows: "shadows",
    shape: "shape",
    shared: "shared",
    local: "local",
    singleton: "singleton",
    site: "site",
    slots: "slots",
    softDelete: "softDelete",
    source: "source",
    sourceBehavior: "sourceBehavior",
    sourceEntityDefinition: "sourceEntityDefinition",
    spacing: "spacing",
    stateMachine: "stateMachine",
    states: "states",
    style: "style",
    subDomain: "subDomain",
    suggestedGuards: "suggestedGuards",
    summary: "summary",
    surfaces: "surfaces",
    synonyms: "synonyms",
    target: "target",
    targetView: "targetView",
    text: "text",
    theme: "theme",
    tick: "tick",
    ticks: "ticks",
    tier: "tier",
    timeBoundMs: "timeBoundMs",
    timeout: "timeout",
    timestamps: "timestamps",
    title: "title",
    to: "to",
    tokens: "tokens",
    trait: "trait",
    traitEmbedIds: "traitEmbedIds",
    traitId: "traitId",
    traitName: "traitName",
    traitRefIds: "traitRefIds",
    traits: "traits",
    transition: "transition",
    transitions: "transitions",
    triggers: "triggers",
    triggersId: "triggersId",
    type: "type",
    typeArgs: "typeArgs",
    typeParams: "typeParams",
    typeScale: "typeScale",
    typeWhen: "typeWhen",
    types: "types",
    typography: "typography",
    ui: "ui",
    unique: "unique",
    update: "update",
    update_policy: "update_policy",
    updatedAt: "updatedAt",
    url: "url",
    uses: "uses",
    uxHints: "uxHints",
    values: "values",
    variant: "variant",
    variants: "variants",
    version: "version",
    viewType: "viewType",
    visual_prompt: "visual_prompt",
    vocabulary: "vocabulary"
  }
};

// src/i18n/ar.json
var ar_default = {
  meta: {
    code: "ar",
    name: "Arabic",
    rtl: true
  },
  keywords: {
    app: "\u062A\u0637\u0628\u064A\u0642",
    orbital: "\u0645\u062F\u0627\u0631",
    uses: "\u064A\u0633\u062A\u062E\u062F\u0645",
    expects: "\u064A\u062A\u0648\u0642\u0639",
    entity: "\u0643\u064A\u0627\u0646",
    type: "\u0646\u0648\u0639",
    derived: "\u0645\u0634\u062A\u0642",
    trait: "\u0633\u0645\u0629",
    initial: "\u0623\u0648\u0644\u064A",
    state: "\u062D\u0627\u0644\u0629",
    for: "\u0645\u0646_\u0623\u062C\u0644",
    page: "\u0635\u0641\u062D\u0629",
    as: "\u0643\u0640",
    theme: "\u0645\u0638\u0647\u0631",
    emits: "\u064A\u0635\u062F\u0631",
    listens: "\u064A\u0633\u062A\u0645\u0639",
    ticks: "\u0646\u0628\u0636\u0627\u062A",
    config: "\u062A\u0643\u0648\u064A\u0646",
    when: "\u0639\u0646\u062F\u0645\u0627",
    with: "\u0645\u0639",
    from: "\u0645\u0646",
    to: "\u0625\u0644\u0649",
    every: "\u0643\u0644",
    capabilities: "\u0642\u062F\u0631\u0627\u062A",
    match: "\u0645\u0637\u0627\u0628\u0642\u0629",
    external: "\u062E\u0627\u0631\u062C\u064A",
    internal: "\u062F\u0627\u062E\u0644\u064A",
    on: "\u0639\u0646\u062F",
    name: "\u0627\u0633\u0645",
    fields: "\u062D\u0642\u0648\u0644",
    events: "\u0623\u062D\u062F\u0627\u062B",
    event: "\u062D\u062F\u062B",
    emitsScope: "\u0646\u0637\u0627\u0642_\u0627\u0644\u0625\u0635\u062F\u0627\u0631",
    identity: "\u0647\u0648\u064A\u0629",
    pages: "\u0635\u0641\u062D\u0627\u062A",
    omit: "\u0627\u0633\u062A\u0628\u0639\u0627\u062F",
    only: "\u0641\u0642\u0637",
    roles: "\u0623\u062F\u0648\u0627\u0631",
    entities: "\u0643\u064A\u0627\u0646\u0627\u062A",
    extend: "\u0627\u0645\u062A\u062F\u0627\u062F"
  },
  shapes: {
    Entity: "\u0643\u064A\u0627\u0646",
    Trait: "\u0633\u0645\u0629",
    Page: "\u0635\u0641\u062D\u0629",
    Orbital: "\u0645\u062F\u0627\u0631",
    Event: "\u062D\u062F\u062B"
  },
  tags: {
    persistent: "\u062F\u0627\u0626\u0645",
    runtime: "\u0648\u0642\u062A_\u0627\u0644\u062A\u0634\u063A\u064A\u0644",
    shared: "\u0645\u0634\u062A\u0631\u0643",
    local: "\u0645\u062D\u0644\u064A",
    identity: "\u0647\u0648\u064A\u0629",
    instance: "\u0646\u0633\u062E\u0629",
    collection: "\u0645\u062C\u0645\u0648\u0639\u0629"
  },
  categories: {
    interaction: "\u062A\u0641\u0627\u0639\u0644",
    integration: "\u062A\u0643\u0627\u0645\u0644",
    lifecycle: "\u062F\u0648\u0631\u0629_\u062D\u064A\u0627\u0629",
    "game-core": "\u0623\u0633\u0627\u0633\u064A\u0627\u062A_\u0627\u0644\u0644\u0639\u0628\u0629",
    "game-entity": "\u0643\u064A\u0627\u0646_\u0627\u0644\u0644\u0639\u0628\u0629",
    "game-ui": "\u0648\u0627\u062C\u0647\u0629_\u0627\u0644\u0644\u0639\u0628\u0629"
  },
  capabilities: {
    read: "\u0642\u0631\u0627\u0621\u0629",
    write: "\u0643\u062A\u0627\u0628\u0629",
    browse: "\u062A\u0635\u0641\u062D",
    create: "\u0625\u0646\u0634\u0627\u0621",
    update: "\u062A\u062D\u062F\u064A\u062B",
    delete: "\u062D\u0630\u0641",
    notify: "\u0625\u0634\u0639\u0627\u0631",
    schedule: "\u062C\u062F\u0648\u0644\u0629",
    invoke: "\u0627\u0633\u062A\u062F\u0639\u0627\u0621"
  },
  annotations: {
    key: "\u0645\u0641\u062A\u0627\u062D",
    unique: "\u0641\u0631\u064A\u062F",
    intrinsic: "\u062C\u0648\u0647\u0631\u064A",
    label: "\u062A\u0633\u0645\u064A\u0629",
    description: "\u0648\u0635\u0641",
    synonyms: "\u0645\u0631\u0627\u062F\u0641\u0627\u062A",
    mock: "\u0648\u0647\u0645\u064A",
    tier: "\u0645\u0633\u062A\u0648\u0649",
    rebindable: "\u0642\u0627\u0628\u0644_\u0644\u0625\u0639\u0627\u062F\u0629_\u0627\u0644\u0631\u0628\u0637",
    read: "\u0642\u0631\u0627\u0621\u0629",
    create: "\u0625\u0646\u0634\u0627\u0621",
    update: "\u062A\u062D\u062F\u064A\u062B",
    delete: "\u062D\u0630\u0641",
    icon: "\u0623\u064A\u0642\u0648\u0646\u0629"
  },
  sigils: {
    entity: "\u0643\u064A\u0627\u0646",
    payload: "\u062D\u0645\u0648\u0644\u0629",
    state: "\u062D\u0627\u0644\u0629",
    now: "\u0627\u0644\u0622\u0646",
    config: "\u062A\u0643\u0648\u064A\u0646",
    user: "\u0645\u0633\u062A\u062E\u062F\u0645",
    trait: "\u0633\u0645\u0629"
  },
  effects: {
    set: "\u062A\u0639\u064A\u064A\u0646",
    fetch: "\u062C\u0644\u0628",
    persist: "\u062D\u0641\u0638",
    emit: "\u0628\u062B",
    navigate: "\u0627\u0646\u062A\u0642\u0627\u0644",
    "navigate-back": "\u0631\u062C\u0648\u0639",
    "render-ui": "\u0639\u0631\u0636_\u0648\u0627\u062C\u0647\u0629",
    notify: "\u0625\u0634\u0639\u0627\u0631",
    ref: "\u0645\u0631\u062C\u0639",
    "call-service": "\u0627\u0633\u062A\u062F\u0639\u0627\u0621_\u062E\u062F\u0645\u0629",
    invoke: "\u0627\u0633\u062A\u062F\u0639\u0627\u0621",
    do: "\u062A\u0646\u0641\u064A\u0630",
    if: "\u0625\u0630\u0627",
    let: "\u0644\u064A\u0643\u0646",
    fn: "\u062F\u0627\u0644\u0629",
    lambda: "\u0644\u0627\u0645\u062F\u0627",
    match: "\u0645\u0637\u0627\u0628\u0642\u0629",
    when: "\u0639\u0646\u062F\u0645\u0627"
  },
  types: {
    string: "\u0646\u0635",
    number: "\u0631\u0642\u0645",
    int: "\u0639\u062F\u062F_\u0635\u062D\u064A\u062D",
    float: "\u0639\u0634\u0631\u064A",
    bool: "\u062B\u0646\u0627\u0626\u064A",
    boolean: "\u0645\u0646\u0637\u0642\u064A",
    timestamp: "\u0637\u0627\u0628\u0639_\u0632\u0645\u0646\u064A",
    date: "\u062A\u0627\u0631\u064A\u062E",
    datetime: "\u062A\u0627\u0631\u064A\u062E_\u0648\u0648\u0642\u062A",
    duration: "\u0645\u062F\u0629",
    money: "\u0645\u0628\u0644\u063A_\u0645\u0627\u0644\u064A",
    scalar: "\u0639\u062F\u062F\u064A",
    file: "\u0645\u0644\u0641",
    email: "\u0628\u0631\u064A\u062F_\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
    url: "\u0631\u0627\u0628\u0637",
    phone: "\u0647\u0627\u062A\u0641",
    uuid: "\u0645\u0639\u0631\u0641_\u0641\u0631\u064A\u062F",
    image: "\u0635\u0648\u0631\u0629",
    icon: "\u0623\u064A\u0642\u0648\u0646\u0629",
    asset: "\u0623\u0635\u0644",
    component: "\u0645\u0643\u0648\u0646",
    object: "\u0643\u0627\u0626\u0646",
    array: "\u0645\u0635\u0641\u0648\u0641\u0629",
    enum: "\u062A\u0639\u062F\u0627\u062F",
    relation: "\u0639\u0644\u0627\u0642\u0629",
    node: "\u0639\u0642\u062F\u0629",
    union: "\u0627\u062A\u062D\u0627\u062F",
    void: "\u0641\u0631\u0627\u063A",
    null: "\u0639\u062F\u0645",
    any: "\u0623\u064A",
    trait: "\u0633\u0645\u0629",
    entity: "\u0643\u064A\u0627\u0646",
    event: "\u062D\u062F\u062B",
    slot: "\u0641\u062A\u062D\u0629",
    pattern: "\u0646\u0645\u0637",
    Map: "\u062E\u0631\u064A\u0637\u0629",
    secret: "\u0633\u0631",
    SExpr: "\u062A\u0639\u0628\u064A\u0631_\u0631\u0645\u0632\u064A"
  },
  units: {
    ms: "\u0645\u0644\u0644\u064A_\u062B\u0627\u0646\u064A\u0629",
    s: "\u062B\u0627\u0646\u064A\u0629",
    m: "\u062F\u0642\u064A\u0642\u0629",
    h: "\u0633\u0627\u0639\u0629",
    d: "\u064A\u0648\u0645"
  },
  literals: {
    true: "\u0635\u062D\u064A\u062D",
    false: "\u062E\u0627\u0637\u0626",
    null: "\u0639\u062F\u0645"
  },
  reservedEvents: {
    INIT: "\u062A\u0647\u064A\u0626\u0629"
  },
  orb: {
    _metadata: "\u0628\u064A\u0627\u0646\u0627\u062A_\u0648\u0635\u0641\u064A\u0629",
    _resolved: "_\u0645\u062D\u0644\u0648\u0644",
    access_waivers: "\u0625\u0639\u0641\u0627\u0621\u0627\u062A_\u0627\u0644\u0648\u0635\u0648\u0644",
    alias: "\u0627\u0633\u0645_\u0645\u0633\u062A\u0639\u0627\u0631",
    animations: "\u0631\u0633\u0648\u0645_\u0645\u062A\u062D\u0631\u0643\u0629",
    appliesTo: "\u064A\u0646\u0637\u0628\u0642_\u0639\u0644\u0649",
    as: "\u0643\u0640",
    aspect: "\u0646\u0633\u0628\u0629",
    assetRef: "\u0645\u0631\u062C\u0639_\u0627\u0644\u0623\u0635\u0644",
    at: "\u0641\u064A",
    auth: "\u0645\u0635\u0627\u062F\u0642\u0629",
    auxiliaryEntities: "\u0643\u064A\u0627\u0646\u0627\u062A_\u0645\u0633\u0627\u0639\u062F\u0629",
    bakedName: "\u0627\u0633\u0645_\u0645\u062E\u0628\u0648\u0632",
    baseUrl: "\u0631\u0627\u0628\u0637_\u0623\u0633\u0627\u0633\u064A",
    behavior: "\u0633\u0644\u0648\u0643",
    capabilities: "\u0642\u062F\u0631\u0627\u062A",
    cardinality: "\u062A\u0639\u062F\u062F\u064A\u0629",
    category: "\u0641\u0626\u0629",
    className: "\u0627\u0633\u0645_\u0627\u0644\u0641\u0626\u0629",
    classification: "\u062A\u0635\u0646\u064A\u0641",
    collection: "\u0645\u062C\u0645\u0648\u0639\u0629",
    color: "\u0644\u0648\u0646",
    colors: "\u0623\u0644\u0648\u0627\u0646",
    component: "\u0645\u0643\u0648\u0646",
    config: "\u062A\u0643\u0648\u064A\u0646",
    configProvenance: "\u0645\u0635\u062F\u0631_\u0627\u0644\u062A\u0643\u0648\u064A\u0646",
    container: "\u062D\u0627\u0648\u064A\u0629",
    content: "\u0645\u062D\u062A\u0648\u0649",
    create: "\u0625\u0646\u0634\u0627\u0621",
    create_policy: "\u0633\u064A\u0627\u0633\u0629_\u0627\u0644\u0625\u0646\u0634\u0627\u0621",
    createdAt: "\u062A\u0627\u0631\u064A\u062E_\u0627\u0644\u0625\u0646\u0634\u0627\u0621",
    curName: "\u0627\u0644\u0627\u0633\u0645_\u0627\u0644\u062D\u0627\u0644\u064A",
    customPatterns: "\u0623\u0646\u0645\u0627\u0637_\u0645\u062E\u0635\u0635\u0629",
    darkMode: "\u0627\u0644\u0648\u0636\u0639_\u0627\u0644\u062F\u0627\u0643\u0646",
    dataEntities: "\u0643\u064A\u0627\u0646\u0627\u062A_\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
    default: "\u0627\u0641\u062A\u0631\u0627\u0636\u064A",
    definerKnob: "\u0645\u0642\u0628\u0636_\u0627\u0644\u0645\u064F\u0639\u0631\u0650\u0651\u0641",
    delayMs: "\u062A\u0623\u062E\u064A\u0631_\u0645\u0644\u0644\u064A_\u062B\u0627\u0646\u064A\u0629",
    delete: "\u062D\u0630\u0641",
    delete_policy: "\u0633\u064A\u0627\u0633\u0629_\u0627\u0644\u062D\u0630\u0641",
    density: "\u0643\u062B\u0627\u0641\u0629",
    description: "\u0648\u0635\u0641",
    description_visual_prompt: "\u0648\u0635\u0641_\u0627\u0644\u0645\u0648\u062C\u0647_\u0627\u0644\u0628\u0635\u0631\u064A",
    design: "\u062A\u0635\u0645\u064A\u0645",
    designTokens: "\u0631\u0645\u0648\u0632_\u0627\u0644\u062A\u0635\u0645\u064A\u0645",
    detailPattern: "\u0646\u0645\u0637_\u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644",
    device: "\u062C\u0647\u0627\u0632",
    dimension: "\u0628\u064F\u0639\u062F",
    domainContext: "\u0633\u064A\u0627\u0642_\u0627\u0644\u0645\u062C\u0627\u0644",
    effectRow: "\u0635\u0641_\u0627\u0644\u062A\u0623\u062B\u064A\u0631",
    effects: "\u062A\u0623\u062B\u064A\u0631\u0627\u062A",
    elevation: "\u0627\u0631\u062A\u0641\u0627\u0639",
    emitIds: "\u0645\u0639\u0631\u0641\u0627\u062A_\u0627\u0644\u0628\u062B",
    emits: "\u064A\u0635\u062F\u0631",
    emitsScope: "\u0646\u0637\u0627\u0642_\u0627\u0644\u0625\u0635\u062F\u0627\u0631",
    enabled: "\u0645\u064F\u0641\u0639\u0651\u0644",
    entities: "\u0643\u064A\u0627\u0646\u0627\u062A",
    entity: "\u0643\u064A\u0627\u0646",
    entityBindingDescription: "\u0648\u0635\u0641_\u0631\u0628\u0637_\u0627\u0644\u0643\u064A\u0627\u0646",
    entityBindingSynonyms: "\u0645\u0631\u0627\u062F\u0641\u0627\u062A_\u0631\u0628\u0637_\u0627\u0644\u0643\u064A\u0627\u0646",
    entityContract: "\u0639\u0642\u062F_\u0627\u0644\u0643\u064A\u0627\u0646",
    entityId: "\u0645\u0639\u0631\u0641_\u0627\u0644\u0643\u064A\u0627\u0646",
    entityRebindable: "\u0642\u0627\u0628\u0644_\u0644\u0625\u0639\u0627\u062F\u0629_\u0631\u0628\u0637_\u0627\u0644\u0643\u064A\u0627\u0646",
    entityRefIds: "\u0645\u0639\u0631\u0641\u0627\u062A_\u0645\u0631\u062C\u0639_\u0627\u0644\u0643\u064A\u0627\u0646",
    entries: "\u0625\u062F\u062E\u0627\u0644\u0627\u062A",
    env: "\u0628\u064A\u0626\u0629",
    equals: "\u064A\u0633\u0627\u0648\u064A",
    event: "\u062D\u062F\u062B",
    eventId: "\u0645\u0639\u0631\u0641_\u0627\u0644\u062D\u062F\u062B",
    eventIds: "\u0645\u0639\u0631\u0641\u0627\u062A_\u0627\u0644\u062D\u062F\u062B",
    events: "\u0623\u062D\u062F\u0627\u062B",
    expects: "\u064A\u062A\u0648\u0642\u0639",
    exposes: "\u064A\u0639\u0631\u0636",
    extend: "\u0627\u0645\u062A\u062F\u0627\u062F",
    extends: "\u064A\u0645\u062A\u062F",
    extendsId: "\u0645\u0639\u0631\u0641_\u0627\u0644\u0627\u0645\u062A\u062F\u0627\u062F",
    field: "\u062D\u0642\u0644",
    fields: "\u062D\u0642\u0648\u0644",
    flowPattern: "\u0646\u0645\u0637_\u0627\u0644\u062A\u062F\u0641\u0642",
    foreignKey: "\u0645\u0641\u062A\u0627\u062D_\u0623\u062C\u0646\u0628\u064A",
    formPattern: "\u0646\u0645\u0637_\u0627\u0644\u0646\u0645\u0648\u0630\u062C",
    forwardedFrom: "\u0645\u0648\u062C\u0647_\u0645\u0646",
    from: "\u0645\u0646",
    geometry: "\u0647\u0646\u062F\u0633\u0629",
    guard: "\u062D\u0627\u0631\u0633",
    guards: "\u062D\u0631\u0627\u0633",
    headers: "\u062A\u0631\u0648\u064A\u0633\u0627\u062A",
    icon: "\u0623\u064A\u0642\u0648\u0646\u0629",
    iconography: "\u0623\u064A\u0642\u0648\u0646\u0627\u062A",
    id: "\u0645\u0639\u0631\u0641",
    identity: "\u0647\u0648\u064A\u0629",
    illustration: "\u0631\u0633\u0645_\u062A\u0648\u0636\u064A\u062D\u064A",
    inbound: "\u0648\u0627\u0631\u062F",
    initialEffects: "\u0627\u0644\u062A\u0623\u062B\u064A\u0631\u0627\u062A_\u0627\u0644\u0623\u0648\u0644\u064A\u0629",
    instances: "\u0646\u0633\u062E",
    interactive: "\u062A\u0641\u0627\u0639\u0644\u064A",
    interval: "\u0641\u0627\u0635\u0644_\u0632\u0645\u0646\u064A",
    intrinsic: "\u062C\u0648\u0647\u0631\u064A",
    isFinal: "\u0623\u062E\u064A\u0631",
    isInitial: "\u0623\u0648\u0644\u064A",
    isTerminal: "\u0646\u0647\u0627\u0626\u064A",
    item: "\u0639\u0646\u0635\u0631",
    items: "\u0639\u0646\u0627\u0635\u0631",
    key: "\u0645\u0641\u062A\u0627\u062D",
    keyName: "\u0627\u0633\u0645_\u0627\u0644\u0645\u0641\u062A\u0627\u062D",
    kind: "\u0635\u0646\u0641",
    knob: "\u0645\u0642\u0628\u0636",
    label: "\u062A\u0633\u0645\u064A\u0629",
    ledger: "\u0633\u062C\u0644",
    linkedEntity: "\u0643\u064A\u0627\u0646_\u0645\u0631\u062A\u0628\u0637",
    linkedEntityId: "\u0645\u0639\u0631\u0641_\u0627\u0644\u0643\u064A\u0627\u0646_\u0627\u0644\u0645\u0631\u062A\u0628\u0637",
    listPattern: "\u0646\u0645\u0637_\u0627\u0644\u0642\u0627\u0626\u0645\u0629",
    listens: "\u064A\u0633\u062A\u0645\u0639",
    location: "\u0645\u0648\u0642\u0639",
    max: "\u0623\u0642\u0635\u0649",
    maxAttempts: "\u0623\u0642\u0635\u0649_\u0639\u062F\u062F_\u0645\u062D\u0627\u0648\u0644\u0627\u062A",
    mergedFrom: "\u0645\u062F\u0645\u062C_\u0645\u0646",
    min: "\u0623\u062F\u0646\u0649",
    mock: "\u0648\u0647\u0645\u064A",
    motion: "\u062D\u0631\u0643\u0629",
    mounts: "\u062A\u0631\u0643\u064A\u0628\u0627\u062A",
    name: "\u0627\u0633\u0645",
    omit: "\u0627\u0633\u062A\u0628\u0639\u0627\u062F",
    onDelete: "\u0639\u0646\u062F_\u0627\u0644\u062D\u0630\u0641",
    onEntry: "\u0639\u0646\u062F_\u0627\u0644\u062F\u062E\u0648\u0644",
    onExit: "\u0639\u0646\u062F_\u0627\u0644\u062E\u0631\u0648\u062C",
    only: "\u0641\u0642\u0637",
    orbital: "\u0645\u062F\u0627\u0631",
    orbitalId: "\u0645\u0639\u0631\u0641_\u0627\u0644\u0645\u062F\u0627\u0631",
    orbitals: "\u0645\u062F\u0627\u0631\u0627\u062A",
    originalEvent: "\u0627\u0644\u062D\u062F\u062B_\u0627\u0644\u0623\u0635\u0644\u064A",
    originalName: "\u0627\u0644\u0627\u0633\u0645_\u0627\u0644\u0623\u0635\u0644\u064A",
    outbound: "\u0635\u0627\u062F\u0631",
    owner: "\u0645\u0627\u0644\u0643",
    pageIds: "\u0645\u0639\u0631\u0641\u0627\u062A_\u0627\u0644\u0635\u0641\u062D\u0629",
    pages: "\u0635\u0641\u062D\u0627\u062A",
    parent: "\u0623\u0628",
    path: "\u0645\u0633\u0627\u0631",
    pattern: "\u0646\u0645\u0637",
    patternPath: "\u0645\u0633\u0627\u0631_\u0627\u0644\u0646\u0645\u0637",
    payload: "\u062D\u0645\u0648\u0644\u0629",
    payloadEntity: "\u0643\u064A\u0627\u0646_\u0627\u0644\u062D\u0645\u0648\u0644\u0629",
    payloadFor: "\u062D\u0645\u0648\u0644\u0629_\u0644\u0623\u062C\u0644",
    payloadMapping: "\u062A\u062E\u0637\u064A\u0637_\u0627\u0644\u062D\u0645\u0648\u0644\u0629",
    payloadSchema: "\u0645\u062E\u0637\u0637_\u0627\u0644\u062D\u0645\u0648\u0644\u0629",
    persistence: "\u0627\u0633\u062A\u0645\u0631\u0627\u0631\u064A\u0629",
    personas: "\u0634\u062E\u0635\u064A\u0627\u062A",
    presentation: "\u0639\u0631\u0636_\u062A\u0642\u062F\u064A\u0645\u064A",
    primaryColor: "\u0627\u0644\u0644\u0648\u0646_\u0627\u0644\u0623\u0633\u0627\u0633\u064A",
    primaryEntity: "\u0627\u0644\u0643\u064A\u0627\u0646_\u0627\u0644\u0623\u0633\u0627\u0633\u064A",
    primaryKey: "\u0645\u0641\u062A\u0627\u062D_\u0623\u0633\u0627\u0633\u064A",
    priority: "\u0623\u0648\u0644\u0648\u064A\u0629",
    prop: "\u062E\u0627\u0635\u064A\u0629",
    properties: "\u062E\u0635\u0627\u0626\u0635",
    props: "\u062E\u0648\u0627\u0635",
    provides: "\u064A\u0648\u0641\u0631",
    radii: "\u0623\u0646\u0635\u0627\u0641_\u0623\u0642\u0637\u0627\u0631",
    read: "\u0642\u0631\u0627\u0621\u0629",
    read_policy: "\u0633\u064A\u0627\u0633\u0629_\u0627\u0644\u0642\u0631\u0627\u0621\u0629",
    reconnect: "\u0625\u0639\u0627\u062F\u0629_\u0627\u0644\u0627\u062A\u0635\u0627\u0644",
    ref: "\u0645\u0631\u062C\u0639",
    refId: "\u0645\u0639\u0631\u0641_\u0627\u0644\u0645\u0631\u062C\u0639",
    reference: "\u0645\u0631\u062C\u0639\u064A\u0629",
    relatedLinks: "\u0631\u0648\u0627\u0628\u0637_\u0630\u0627\u062A_\u0635\u0644\u0629",
    relation: "\u0639\u0644\u0627\u0642\u0629",
    renames: "\u0625\u0639\u0627\u062F\u0629_\u062A\u0633\u0645\u064A\u0629",
    request: "\u0637\u0644\u0628",
    requestFragment: "\u062C\u0632\u0621_\u0627\u0644\u0637\u0644\u0628",
    required: "\u0645\u0637\u0644\u0648\u0628",
    requiredFields: "\u0627\u0644\u062D\u0642\u0648\u0644_\u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629",
    requires: "\u064A\u062A\u0637\u0644\u0628",
    resolved: "\u0645\u062D\u0644\u0648\u0644",
    resource: "\u0645\u0648\u0631\u062F",
    role: "\u062F\u0648\u0631",
    roles: "\u0623\u062F\u0648\u0627\u0631",
    runtime: "\u0648\u0642\u062A_\u0627\u0644\u062A\u0634\u063A\u064A\u0644",
    schemaVersion: "\u0625\u0635\u062F\u0627\u0631_\u0627\u0644\u0645\u062E\u0637\u0637",
    scope: "\u0646\u0637\u0627\u0642",
    scopeOverridden: "\u0627\u0644\u0646\u0637\u0627\u0642_\u0645\u064F\u062A\u062C\u0627\u0648\u064E\u0632",
    secretEnv: "\u0628\u064A\u0626\u0629_\u0633\u0631\u064A\u0629",
    sections: "\u0623\u0642\u0633\u0627\u0645",
    semanticRole: "\u062F\u0648\u0631_\u062F\u0644\u0627\u0644\u064A",
    serverPath: "\u0645\u0633\u0627\u0631_\u0627\u0644\u062E\u0627\u062F\u0645",
    services: "\u062E\u062F\u0645\u0627\u062A",
    shadows: "\u0638\u0644\u0627\u0644",
    shape: "\u0634\u0643\u0644",
    shared: "\u0645\u0634\u062A\u0631\u0643",
    local: "\u0645\u062D\u0644\u064A",
    singleton: "\u0648\u062D\u064A\u062F",
    site: "\u0645\u0648\u0642\u0639_\u0627\u0644\u0648\u064A\u0628",
    slots: "\u0641\u062A\u062D\u0627\u062A",
    softDelete: "\u062D\u0630\u0641_\u0646\u0627\u0639\u0645",
    source: "\u0645\u0635\u062F\u0631",
    sourceBehavior: "\u0633\u0644\u0648\u0643_\u0627\u0644\u0645\u0635\u062F\u0631",
    sourceEntityDefinition: "\u062A\u0639\u0631\u064A\u0641_\u0643\u064A\u0627\u0646_\u0627\u0644\u0645\u0635\u062F\u0631",
    spacing: "\u062A\u0628\u0627\u0639\u062F",
    stateMachine: "\u0622\u0644\u0629_\u062D\u0627\u0644\u0629",
    states: "\u062D\u0627\u0644\u0627\u062A",
    style: "\u0623\u0633\u0644\u0648\u0628",
    subDomain: "\u0645\u062C\u0627\u0644_\u0641\u0631\u0639\u064A",
    suggestedGuards: "\u0627\u0644\u062D\u0631\u0627\u0633_\u0627\u0644\u0645\u0642\u062A\u0631\u062D\u0648\u0646",
    summary: "\u0645\u0644\u062E\u0635",
    surfaces: "\u0623\u0633\u0637\u062D",
    synonyms: "\u0645\u0631\u0627\u062F\u0641\u0627\u062A",
    target: "\u0647\u062F\u0641",
    targetView: "\u0627\u0644\u0639\u0631\u0636_\u0627\u0644\u0645\u0633\u062A\u0647\u062F\u0641",
    text: "\u0646\u0635",
    theme: "\u0645\u0638\u0647\u0631",
    tick: "\u0646\u0628\u0636\u0629",
    ticks: "\u0646\u0628\u0636\u0627\u062A",
    tier: "\u0645\u0633\u062A\u0648\u0649",
    timeBoundMs: "\u062D\u062F_\u0632\u0645\u0646\u064A_\u0645\u0644\u0644\u064A_\u062B\u0627\u0646\u064A\u0629",
    timeout: "\u0645\u0647\u0644\u0629",
    timestamps: "\u0637\u0648\u0627\u0628\u0639_\u0632\u0645\u0646\u064A\u0629",
    title: "\u0639\u0646\u0648\u0627\u0646",
    to: "\u0625\u0644\u0649",
    tokens: "\u0631\u0645\u0648\u0632",
    trait: "\u0633\u0645\u0629",
    traitEmbedIds: "\u0645\u0639\u0631\u0641\u0627\u062A_\u062A\u0636\u0645\u064A\u0646_\u0627\u0644\u0633\u0645\u0629",
    traitId: "\u0645\u0639\u0631\u0641_\u0627\u0644\u0633\u0645\u0629",
    traitName: "\u0627\u0633\u0645_\u0627\u0644\u0633\u0645\u0629",
    traitRefIds: "\u0645\u0639\u0631\u0641\u0627\u062A_\u0645\u0631\u062C\u0639_\u0627\u0644\u0633\u0645\u0629",
    traits: "\u0633\u0645\u0627\u062A",
    transition: "\u0627\u0646\u062A\u0642\u0627\u0644_\u062D\u0627\u0644\u0629",
    transitions: "\u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A",
    triggers: "\u0645\u062D\u0641\u0632\u0627\u062A",
    triggersId: "\u0645\u0639\u0631\u0641_\u0627\u0644\u0645\u062D\u0641\u0632\u0627\u062A",
    type: "\u0646\u0648\u0639",
    typeArgs: "\u0648\u0633\u0627\u0626\u0637_\u0627\u0644\u0646\u0648\u0639",
    typeParams: "\u0645\u0639\u0627\u0645\u0644\u0627\u062A_\u0627\u0644\u0646\u0648\u0639",
    typeScale: "\u0645\u0642\u064A\u0627\u0633_\u0627\u0644\u0637\u0628\u0627\u0639\u0629",
    typeWhen: "\u0646\u0648\u0639_\u0639\u0646\u062F\u0645\u0627",
    types: "\u0623\u0646\u0648\u0627\u0639",
    typography: "\u0637\u0628\u0627\u0639\u0629",
    ui: "\u0648\u0627\u062C\u0647\u0629",
    unique: "\u0641\u0631\u064A\u062F",
    update: "\u062A\u062D\u062F\u064A\u062B",
    update_policy: "\u0633\u064A\u0627\u0633\u0629_\u0627\u0644\u062A\u062D\u062F\u064A\u062B",
    updatedAt: "\u062A\u0627\u0631\u064A\u062E_\u0627\u0644\u062A\u062D\u062F\u064A\u062B",
    url: "\u0631\u0627\u0628\u0637",
    uses: "\u064A\u0633\u062A\u062E\u062F\u0645",
    uxHints: "\u062A\u0644\u0645\u064A\u062D\u0627\u062A_\u062A\u062C\u0631\u0628\u0629_\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
    values: "\u0642\u064A\u0645",
    variant: "\u0645\u062A\u063A\u064A\u0631",
    variants: "\u0645\u062A\u063A\u064A\u0631\u0627\u062A",
    version: "\u0625\u0635\u062F\u0627\u0631",
    viewType: "\u0646\u0648\u0639_\u0627\u0644\u0639\u0631\u0636",
    visual_prompt: "\u0645\u0648\u062C\u0647_\u0628\u0635\u0631\u064A",
    vocabulary: "\u0645\u0641\u0631\u062F\u0627\u062A"
  }
};

// src/i18n/sl.json
var sl_default = {
  meta: {
    code: "sl",
    name: "Slovenian",
    rtl: false
  },
  keywords: {
    app: "aplikacija",
    orbital: "orbitala",
    uses: "uporablja",
    expects: "pricakuje",
    entity: "entiteta",
    type: "tip",
    derived: "izpeljano",
    trait: "znacilnost",
    initial: "zacetno",
    state: "stanje",
    for: "za",
    page: "stran",
    as: "kot",
    theme: "tema",
    emits: "oddaja",
    listens: "poslusa",
    ticks: "utripi",
    config: "konfiguracija",
    when: "ko",
    with: "s",
    from: "iz",
    to: "do",
    every: "vsak",
    capabilities: "zmoznosti",
    match: "ujemaj",
    external: "zunanje",
    internal: "notranje",
    on: "ob",
    name: "ime",
    fields: "polja",
    events: "dogodki",
    event: "dogodek",
    emitsScope: "oddajaObseg",
    identity: "identiteta",
    pages: "strani",
    omit: "izloci",
    only: "samo",
    roles: "vloge",
    entities: "entitete",
    extend: "razsiritev"
  },
  shapes: {
    Entity: "Entiteta",
    Trait: "Znacilnost",
    Page: "Stran",
    Orbital: "Orbitala",
    Event: "Dogodek"
  },
  tags: {
    persistent: "trajno",
    runtime: "izvajanje",
    shared: "skupno",
    local: "lokalno",
    identity: "identiteta",
    instance: "primerek",
    collection: "zbirka"
  },
  categories: {
    interaction: "interakcija",
    integration: "integracija",
    lifecycle: "zivljenjskiCikel",
    "game-core": "igra-jedro",
    "game-entity": "igra-entiteta",
    "game-ui": "igra-vmesnik"
  },
  capabilities: {
    read: "beri",
    write: "pisi",
    browse: "brskaj",
    create: "ustvari",
    update: "posodobi",
    delete: "izbrisi",
    notify: "obvesti",
    schedule: "razporedi",
    invoke: "sprozi"
  },
  annotations: {
    key: "kljuc",
    unique: "edinstveno",
    intrinsic: "lastno",
    label: "oznaka",
    description: "opis",
    synonyms: "sopomenke",
    mock: "lazno",
    tier: "nivo",
    rebindable: "prevezljivo",
    read: "beri",
    create: "ustvari",
    update: "posodobi",
    delete: "izbrisi",
    icon: "ikona"
  },
  sigils: {
    entity: "entiteta",
    payload: "podatki",
    state: "stanje",
    now: "zdaj",
    config: "konfiguracija",
    user: "uporabnik",
    trait: "znacilnost"
  },
  effects: {
    set: "nastavi",
    fetch: "pridobi",
    persist: "shrani",
    emit: "oddaj",
    navigate: "pojdi",
    "navigate-back": "pojdi-nazaj",
    "render-ui": "izrisi-vmesnik",
    notify: "obvesti",
    ref: "sklic",
    "call-service": "poklici-storitev",
    invoke: "sprozi",
    do: "naredi",
    if: "ce",
    let: "naj",
    fn: "fn",
    lambda: "lambda",
    match: "ujemaj",
    when: "ko"
  },
  types: {
    string: "niz",
    number: "stevilo",
    int: "celo",
    float: "plavajoce",
    bool: "logicna",
    boolean: "logicno",
    timestamp: "casovniZig",
    date: "datum",
    datetime: "datumCas",
    duration: "trajanje",
    money: "denar",
    scalar: "skalar",
    file: "datoteka",
    email: "eposta",
    url: "url",
    phone: "telefon",
    uuid: "uuid",
    image: "slika",
    icon: "ikona",
    asset: "sredstvo",
    component: "komponenta",
    object: "objekt",
    array: "seznam",
    enum: "nastevanje",
    relation: "relacija",
    node: "vozlisce",
    union: "unija",
    void: "prazno",
    null: "nic",
    any: "karkoli",
    trait: "znacilnost",
    entity: "entiteta",
    event: "dogodek",
    slot: "reza",
    pattern: "vzorec",
    Map: "Mapa",
    secret: "skrivnost",
    SExpr: "SIzraz"
  },
  units: {
    ms: "ms",
    s: "sek",
    m: "min",
    h: "ura",
    d: "dan"
  },
  literals: {
    true: "drzi",
    false: "nedrzi",
    null: "nic"
  },
  reservedEvents: {
    INIT: "ZACETEK"
  },
  orb: {
    _metadata: "_metapodatki",
    _resolved: "_razresen",
    access_waivers: "dostop_izjeme",
    alias: "vzdevek",
    animations: "animacije",
    appliesTo: "veljaZa",
    as: "kot",
    aspect: "razmerje",
    assetRef: "sredstvoSklic",
    at: "pri",
    auth: "avtentikacija",
    auxiliaryEntities: "pomozneEntitete",
    bakedName: "zapecenoIme",
    baseUrl: "osnovaUrl",
    behavior: "vedenje",
    capabilities: "zmoznosti",
    cardinality: "kardinalnost",
    category: "kategorija",
    className: "imeRazreda",
    classification: "klasifikacija",
    collection: "zbirka",
    color: "barva",
    colors: "barve",
    component: "komponenta",
    config: "konfiguracija",
    configProvenance: "konfiguracijaIzvor",
    container: "vsebnik",
    content: "vsebina",
    create: "ustvari",
    create_policy: "ustvari_politika",
    createdAt: "ustvarjenoPri",
    curName: "trenutnoIme",
    customPatterns: "lastniVzorci",
    darkMode: "temniNacin",
    dataEntities: "podatkiEntitete",
    default: "privzeto",
    definerKnob: "definitorGumbek",
    delayMs: "zakasnitevMs",
    delete: "izbrisi",
    delete_policy: "izbrisi_politika",
    density: "gostota",
    description: "opis",
    description_visual_prompt: "opis_vizualno_poziv",
    design: "oblikovanje",
    designTokens: "oblikovanjeZetoni",
    detailPattern: "vzorecPodrobnosti",
    device: "naprava",
    dimension: "dimenzija",
    domainContext: "domenaKontekst",
    effectRow: "ucinekVrstica",
    effects: "ucinki",
    elevation: "dvig",
    emitIds: "oddajIdji",
    emits: "oddaja",
    emitsScope: "oddajaObseg",
    enabled: "omogoceno",
    entities: "entitete",
    entity: "entiteta",
    entityBindingDescription: "entitetaVezavaOpis",
    entityBindingSynonyms: "entitetaVezavaSopomenke",
    entityContract: "entitetaPogodba",
    entityId: "entitetaId",
    entityRebindable: "entitetaPrevezljivo",
    entityRefIds: "entitetaSklicIdji",
    entries: "vnosi",
    env: "okolje",
    equals: "enako",
    event: "dogodek",
    eventId: "dogodekId",
    eventIds: "dogodekIdji",
    events: "dogodki",
    expects: "pricakuje",
    exposes: "izpostavlja",
    extend: "razsiritev",
    extends: "razsiri",
    extendsId: "razsiriId",
    field: "polje",
    fields: "polja",
    flowPattern: "vzorecPoteka",
    foreignKey: "tujiKljuc",
    formPattern: "vzorecObrazca",
    forwardedFrom: "posredovanoOd",
    from: "iz",
    geometry: "geometrija",
    guard: "strazar",
    guards: "strazarji",
    headers: "glave",
    icon: "ikona",
    iconography: "ikonografija",
    id: "id",
    identity: "identiteta",
    illustration: "ilustracija",
    inbound: "dohodno",
    initialEffects: "zacetnoUcinki",
    instances: "primerki",
    interactive: "interaktivno",
    interval: "interval",
    intrinsic: "lastno",
    isFinal: "jeKoncno",
    isInitial: "jeZacetno",
    isTerminal: "jeTerminalno",
    item: "element",
    items: "elementi",
    key: "kljuc",
    keyName: "imeKljuca",
    kind: "vrsta",
    knob: "gumbek",
    label: "oznaka",
    ledger: "knjiga",
    linkedEntity: "povezanaEntiteta",
    linkedEntityId: "povezanaEntitetaId",
    listPattern: "vzorecSeznama",
    listens: "poslusa",
    location: "lokacija",
    max: "najvec",
    maxAttempts: "najvecPoskusov",
    mergedFrom: "zdruzenoIz",
    min: "najmanj",
    mock: "lazno",
    motion: "gibanje",
    mounts: "priklopi",
    name: "ime",
    omit: "izloci",
    onDelete: "obIzbrisi",
    onEntry: "obVnos",
    onExit: "obIzhod",
    only: "samo",
    orbital: "orbitala",
    orbitalId: "orbitalaId",
    orbitals: "orbitale",
    originalEvent: "izvirniDogodek",
    originalName: "izvirnoIme",
    outbound: "odhodno",
    owner: "lastnik",
    pageIds: "stranIdji",
    pages: "strani",
    parent: "stars",
    path: "pot",
    pattern: "vzorec",
    patternPath: "potVzorca",
    payload: "podatki",
    payloadEntity: "podatkiEntiteta",
    payloadFor: "podatkiZa",
    payloadMapping: "podatkiPreslikava",
    payloadSchema: "podatkiShema",
    persistence: "trajnost",
    personas: "osebe",
    presentation: "predstavitev",
    primaryColor: "primarnaBarva",
    primaryEntity: "primarnaEntiteta",
    primaryKey: "primarniKljuc",
    priority: "prioriteta",
    prop: "rekvizit",
    properties: "lastnosti",
    props: "rekviziti",
    provides: "zagotavlja",
    radii: "polmeri",
    read: "beri",
    read_policy: "beri_politika",
    reconnect: "ponovnaPovezava",
    ref: "sklic",
    refId: "sklicId",
    reference: "referenca",
    relatedLinks: "povezanePovezave",
    relation: "relacija",
    renames: "preimenovanja",
    request: "zahtevek",
    requestFragment: "zahtevekFragment",
    required: "obvezno",
    requiredFields: "obveznaPolja",
    requires: "zahteva",
    resolved: "razresen",
    resource: "vir",
    role: "vloga",
    roles: "vloge",
    runtime: "izvajanje",
    schemaVersion: "shemaRazlicica",
    scope: "obseg",
    scopeOverridden: "obsegPreglasen",
    secretEnv: "skrivnostOkolje",
    sections: "odseki",
    semanticRole: "semanticnaVloga",
    serverPath: "streznikPot",
    services: "storitve",
    shadows: "sence",
    shape: "oblika",
    shared: "skupno",
    local: "lokalno",
    singleton: "edinec",
    site: "mesto",
    slots: "reze",
    softDelete: "mehkoIzbrisi",
    source: "izvor",
    sourceBehavior: "izvorVedenje",
    sourceEntityDefinition: "izvorEntitetaDefinicija",
    spacing: "razmik",
    stateMachine: "strojStanj",
    states: "stanja",
    style: "slog",
    subDomain: "poddomena",
    suggestedGuards: "predlaganoStrazarji",
    summary: "povzetek",
    surfaces: "povrsine",
    synonyms: "sopomenke",
    target: "cilj",
    targetView: "ciljPogled",
    text: "besedilo",
    theme: "tema",
    tick: "utrip",
    ticks: "utripi",
    tier: "nivo",
    timeBoundMs: "casMejaMs",
    timeout: "casovnaOmejitev",
    timestamps: "casovniZigi",
    title: "naziv",
    to: "do",
    tokens: "zetoni",
    trait: "znacilnost",
    traitEmbedIds: "znacilnostVgraditevIdji",
    traitId: "znacilnostId",
    traitName: "znacilnostIme",
    traitRefIds: "znacilnostSklicIdji",
    traits: "znacilnosti",
    transition: "prehod",
    transitions: "prehodi",
    triggers: "sprozilci",
    triggersId: "sprozilciId",
    type: "tip",
    typeArgs: "tipArgumenti",
    typeParams: "tipParametri",
    typeScale: "tipMerilo",
    typeWhen: "tipKo",
    types: "tipi",
    typography: "tipografija",
    ui: "vmesnik",
    unique: "edinstveno",
    update: "posodobi",
    update_policy: "posodobi_politika",
    updatedAt: "posodobljenoPri",
    url: "url",
    uses: "uporablja",
    uxHints: "uxNamigi",
    values: "vrednosti",
    variant: "varianta",
    variants: "variante",
    version: "razlicica",
    viewType: "tipPogleda",
    visual_prompt: "vizualno_poziv",
    vocabulary: "besednjak"
  }
};

// src/i18n/lolo-lexer.ts
var IDENT_START = /[\p{L}_]/u;
var IDENT_CONTINUE = /[\p{L}\p{N}_/-]/u;
var SIGIL_CONTINUE = /[\p{L}\p{N}_.]/u;
var DIGIT = /[0-9]/;
function lexLolo(source) {
  const tokens = [];
  let i = 0;
  const n = source.length;
  const push = (kind, start, end, text, textStart) => {
    tokens.push({
      kind,
      start,
      end,
      text: text ?? source.slice(start, end),
      textStart: textStart ?? start
    });
  };
  while (i < n) {
    const c = source[i];
    if (c === " " || c === "	" || c === "\r" || c === "\n") {
      i++;
      continue;
    }
    if (c === "#") {
      const start2 = i;
      if (source[i + 1] === "=") {
        const close = source.indexOf("=#", i + 2);
        i = close === -1 ? n : close + 2;
      } else {
        const nl = source.indexOf("\n", i);
        i = nl === -1 ? n : nl;
      }
      push("comment", start2, i);
      continue;
    }
    if (c === ";" && source[i + 1] === ";") {
      const start2 = i;
      const nl = source.indexOf("\n", i);
      i = nl === -1 ? n : nl;
      push("comment", start2, i);
      continue;
    }
    if (c === '"') {
      const start2 = i;
      i++;
      while (i < n) {
        if (source[i] === "\\") {
          i += 2;
          continue;
        }
        if (source[i] === '"') {
          i++;
          break;
        }
        i++;
      }
      push("string", start2, Math.min(i, n));
      continue;
    }
    if (c === "@") {
      const start2 = i;
      i++;
      if (source[i] === "(") {
        i++;
        push("punct", start2, i);
        continue;
      }
      const nameStart = i;
      while (i < n && SIGIL_CONTINUE.test(source[i])) i++;
      push("sigil", start2, i, source.slice(nameStart, i), nameStart);
      continue;
    }
    if (c === "?") {
      const start2 = i;
      i++;
      if (i < n && IDENT_START.test(source[i])) {
        const nameStart = i;
        while (i < n && SIGIL_CONTINUE.test(source[i])) i++;
        push("payload-sigil", start2, i, source.slice(nameStart, i), nameStart);
      } else {
        push("payload-sigil", start2, i, "", i);
      }
      continue;
    }
    if (c === "-") {
      const start2 = i;
      if (source[i + 1] === ">") {
        i += 2;
        push("punct", start2, i);
      } else if (source[i + 1] === "-") {
        i += 2;
        push("punct", start2, i);
      } else if (source[i + 1] !== void 0 && DIGIT.test(source[i + 1])) {
        i++;
        while (i < n && (DIGIT.test(source[i]) || source[i] === ".")) i++;
        push("number", start2, i);
      } else {
        i++;
        push("identifier", start2, i);
      }
      continue;
    }
    if (DIGIT.test(c)) {
      const start2 = i;
      while (i < n && (DIGIT.test(source[i]) || source[i] === ".")) i++;
      push("number", start2, i);
      continue;
    }
    if (c === "=" || c === "!" || c === "<" || c === ">") {
      const start2 = i;
      i++;
      if (source[i] === "=") i++;
      const two = i - start2 === 2;
      push(two ? "identifier" : "punct", start2, i);
      continue;
    }
    if (c === "+" || c === "*" || c === "/" || c === "%") {
      const start2 = i;
      i++;
      push("identifier", start2, i);
      continue;
    }
    if (IDENT_START.test(c)) {
      const start2 = i;
      while (i < n && IDENT_CONTINUE.test(source[i])) i++;
      const text = source.slice(start2, i);
      push(text === "true" || text === "false" || text === "null" ? "literal" : "identifier", start2, i, text);
      continue;
    }
    const start = i;
    i++;
    if (c === ":" && source[i] === ":") i++;
    push("punct", start, i);
  }
  return tokens;
}

// src/i18n/localize.ts
var LOLO_SECTIONS = [
  "keywords",
  "shapes",
  "tags",
  "categories",
  "capabilities",
  "annotations",
  "sigils",
  "effects",
  "types",
  "units",
  "literals",
  "reservedEvents"
];
var CANON_ANY_ORDER = [
  "keywords",
  "shapes",
  "tags",
  "categories",
  "capabilities",
  "annotations",
  "sigils",
  "types",
  "units",
  "literals",
  "reservedEvents"
];
function forward(lang, sections, resolutionOrder, operators) {
  const canon = (native) => {
    for (const section of resolutionOrder) {
      for (const [english, value] of Object.entries(coreTables[lang][section])) {
        if (value === native) return english;
      }
    }
    if (operators) {
      for (const [english, value] of Object.entries(operators.operators)) {
        if (value === native) return english;
      }
    }
    return void 0;
  };
  const map = /* @__PURE__ */ new Map();
  const add = (english, native) => {
    if (canon(native) !== english) return;
    map.set(english, native);
  };
  for (const section of sections) {
    for (const [english, native] of Object.entries(coreTables[lang][section])) {
      add(english, native);
    }
  }
  if (operators) {
    for (const [english, native] of Object.entries(operators.operators)) {
      add(english, native);
    }
  }
  return map;
}
function localizeMap(lang, operators) {
  return forward(lang, LOLO_SECTIONS, CANON_ANY_ORDER, operators);
}
function isWordShaped(english) {
  return /^[A-Za-z_][A-Za-z0-9_/-]*$/.test(english);
}
var FIELD_BLOCK_HEADS = /* @__PURE__ */ new Set(["entity", "type", "config", "params", "variants", "tokens", "event"]);
var EVENT_BLOCK_HEADS = /* @__PURE__ */ new Set(["listens", "emits", "events"]);
var NAME_INTRODUCING = /* @__PURE__ */ new Set([
  "app",
  "orbital",
  "entity",
  "trait",
  "state",
  "page",
  "type",
  "event",
  "uses",
  "theme",
  "as",
  "extend"
]);
var NAME_PUNCT = /* @__PURE__ */ new Set(["->", "-->", "\u2192", ".", "--"]);
function localizeLoloSource(source, lang, options = {}) {
  if (lang === "en") return source;
  const { operators } = options;
  const keywords = forward(lang, ["keywords"], CANON_ANY_ORDER);
  const shapes = forward(lang, ["shapes"], CANON_ANY_ORDER);
  const types = forward(lang, ["types"], ["types"]);
  const modifiers = forward(lang, ["tags", "categories", "capabilities", "keywords"], CANON_ANY_ORDER);
  const heads = forward(lang, ["effects"], ["effects"], operators);
  const sigils = forward(lang, ["sigils", "annotations"], ["sigils", "annotations"]);
  const bindingSigils = forward(lang, ["sigils"], ["sigils", "annotations"]);
  const literals = forward(lang, ["literals"], ["literals"]);
  const units = forward(lang, ["units"], ["units"]);
  const reservedEvents = forward(lang, ["reservedEvents"], ["reservedEvents"]);
  const tokens = lexLolo(source);
  const edits = [];
  const stack = [
    {
      kind: "root",
      stmtHead: void 0,
      blockHead: void 0,
      afterColon: false,
      sawEquals: false,
      refBody: false,
      parenHead: void 0,
      binderSeen: false
    }
  ];
  const top = () => stack[stack.length - 1];
  let prev;
  const replace = (token, map) => {
    if (!isWordShaped(token.text)) return;
    const native = map.get(token.text);
    if (native === void 0 || native === token.text) return;
    edits.push({ start: token.textStart, end: token.end, text: native });
  };
  for (let index = 0; index < tokens.length; index++) {
    const token = tokens[index];
    if (token.kind === "comment") continue;
    const frame = top();
    const startsStatement = prev === void 0 || prev.text === "{" || prev.text === "}" || source.slice(prev.end, token.start).includes("\n");
    if (startsStatement) {
      frame.stmtHead = void 0;
      frame.afterColon = false;
      frame.sawEquals = false;
    }
    if (token.kind === "punct") {
      const text = source.slice(token.start, token.end);
      const child = (kind) => ({
        kind,
        stmtHead: void 0,
        blockHead: frame.stmtHead,
        afterColon: false,
        sawEquals: false,
        refBody: frame.refBody || frame.sawEquals,
        parenHead: void 0,
        binderSeen: false
      });
      if (text === "(" || text === "@(") {
        stack.push({ ...child(parenFrame(frame, prev)), blockHead: void 0 });
        if (top().kind === "binder-list") frame.binderSeen = true;
      } else if (text === "{") {
        stack.push(child(braceFrame(frame, prev)));
      } else if (text === "[") {
        stack.push(child(bracketFrame(frame, prev)));
      } else if (text === ")" || text === "}" || text === "]") {
        if (stack.length > 1) stack.pop();
        top().afterColon = false;
        top().sawEquals = false;
      } else if (text === ":") {
        frame.afterColon = true;
      } else if (text === "=") {
        frame.afterColon = false;
        frame.sawEquals = true;
      } else if (text === ",") {
        frame.afterColon = false;
        frame.sawEquals = false;
        frame.stmtHead = void 0;
      }
      prev = token;
      continue;
    }
    const opaque = frame.kind === "object" || frame.kind === "array" || frame.kind === "binder-list" || frame.kind === "binder-pair" && prev !== void 0 && prev.text === "(";
    if (token.kind === "sigil") {
      const dot = token.text.indexOf(".");
      const root = dot === -1 ? token.text : token.text.slice(0, dot);
      const native = (opaque || frame.kind === "paren" ? bindingSigils : sigils).get(root);
      if (native !== void 0 && native !== root) {
        edits.push({ start: token.textStart, end: token.textStart + root.length, text: native });
      }
      prev = token;
      continue;
    }
    if (token.kind === "payload-sigil" || token.kind === "string" || token.kind === "number") {
      prev = token;
      continue;
    }
    if (token.kind === "literal") {
      if (!opaque) replace(token, literals);
      prev = token;
      continue;
    }
    const prevText = prev === void 0 ? void 0 : source.slice(prev.start, prev.end);
    const afterName = prevText !== void 0 && (NAME_INTRODUCING.has(prevText) || NAME_PUNCT.has(prevText));
    if (token.text === "INIT" && !opaque && !frame.sawEquals) {
      replace(token, reservedEvents);
      if (frame.stmtHead === void 0) frame.stmtHead = token.text;
      prev = token;
      continue;
    }
    if (!opaque && !startsStatement && prev !== void 0 && prev.kind === "number") {
      replace(token, units);
      prev = token;
      continue;
    }
    switch (frame.kind) {
      case "paren": {
        if (prevText === "(") {
          frame.parenHead = token.text;
          replace(token, heads);
        }
        break;
      }
      case "binder-list":
      case "binder-pair":
        break;
      case "object":
      case "array":
        break;
      case "mods":
        if (!frame.afterColon) replace(token, modifiers);
        break;
      case "type-array":
        replace(token, types);
        break;
      case "block-fields": {
        if (frame.afterColon && !afterName) replace(token, types);
        break;
      }
      case "root":
      case "block-body": {
        if (!afterName) replace(token, frame.afterColon ? types : keywords);
        break;
      }
    }
    if ((frame.kind === "root" || frame.kind === "block-body") && prevText === "=") {
      replace(token, shapes);
    }
    if (frame.stmtHead === void 0) frame.stmtHead = token.text;
    prev = token;
  }
  return applyEdits(source, edits);
}
function parenFrame(frame, prev) {
  if (frame.kind === "binder-list") return "binder-pair";
  if (frame.kind === "paren" && !frame.binderSeen && prev !== void 0 && prev.text === frame.parenHead && (frame.parenHead === "let" || frame.parenHead === "fn" || frame.parenHead === "lambda")) {
    return "binder-list";
  }
  return "paren";
}
function braceFrame(frame, prev) {
  if (isExpression(frame.kind)) return "object";
  if (frame.kind === "block-fields" && prev !== void 0 && prev.text === "=") return "object";
  if (frame.refBody && frame.stmtHead === "config") return "object";
  if (frame.blockHead !== void 0 && EVENT_BLOCK_HEADS.has(frame.blockHead)) return "block-fields";
  if (frame.kind === "type-array") return "block-fields";
  if (frame.kind === "block-fields" && frame.afterColon) return "block-fields";
  const head = frame.stmtHead;
  return head !== void 0 && FIELD_BLOCK_HEADS.has(head) ? "block-fields" : "block-body";
}
function bracketFrame(frame, prev) {
  if (isExpression(frame.kind)) return "array";
  if (prev !== void 0 && prev.text === "=") return "array";
  if (frame.afterColon) return frame.kind === "block-fields" ? "type-array" : "array";
  return "mods";
}
function isExpression(kind) {
  return kind === "paren" || kind === "object" || kind === "array" || kind === "binder-list" || kind === "binder-pair";
}
function applyEdits(source, edits) {
  if (edits.length === 0) return source;
  edits.sort((a, b) => a.start - b.start);
  let out = "";
  let cursor = 0;
  for (const edit of edits) {
    if (edit.start < cursor) continue;
    out += source.slice(cursor, edit.start) + edit.text;
    cursor = edit.end;
  }
  return out + source.slice(cursor);
}
function localizeOrbValue(value, lang, options = {}) {
  if (lang === "en") return value;
  const orbKeys = forward(lang, ["orb"], ["orb"]);
  const types = forward(lang, ["types"], ["types"]);
  const tags = forward(lang, ["tags"], ["tags"]);
  const heads = forward(lang, ["effects"], ["effects"], options.operators);
  const sigils = forward(lang, ["sigils"], ["sigils", "annotations"]);
  const walk = (node, inExpression) => {
    if (Array.isArray(node)) {
      const head = node[0];
      const native = typeof head === "string" ? heads.get(head) : void 0;
      const isExpression2 = native !== void 0;
      const items = node.map(
        (child, index) => index === 0 && isExpression2 ? child : walk(child, inExpression || isExpression2)
      );
      if (native !== void 0) items[0] = native;
      return items;
    }
    if (node !== null && typeof node === "object") {
      const out = {};
      for (const [key, child] of Object.entries(node)) {
        const nativeKey = orbKeys.get(key) ?? key;
        let next = walk(child, inExpression);
        if (typeof next === "string") {
          if (key === "type" && !inExpression) next = types.get(next) ?? next;
          else if (key === "persistence") next = tags.get(next) ?? next;
        }
        out[nativeKey] = next;
      }
      return out;
    }
    if (typeof node === "string" && node.startsWith("@")) {
      const rest = node.slice(1);
      const dot = rest.indexOf(".");
      const root = dot === -1 ? rest : rest.slice(0, dot);
      const native = sigils.get(root);
      if (native === void 0) return node;
      return dot === -1 ? `@${native}` : `@${native}${rest.slice(dot)}`;
    }
    return node;
  };
  return walk(value, false);
}

// src/i18n/index.ts
var LANGUAGE_CODES = ["en", "ar", "sl"];
var I18N_SECTIONS = [
  "keywords",
  "shapes",
  "tags",
  "categories",
  "capabilities",
  "annotations",
  "sigils",
  "effects",
  "types",
  "units",
  "literals",
  "reservedEvents",
  "orb"
];
function isPlainObject(x) {
  return typeof x === "object" && x !== null && !Array.isArray(x);
}
function isRawI18nTable(x) {
  return isPlainObject(x);
}
function isStringRecord(x) {
  if (!isPlainObject(x)) return false;
  for (const value of Object.values(x)) {
    if (typeof value !== "string") return false;
  }
  return true;
}
function isLanguageCode(x) {
  return x === "en" || x === "ar" || x === "sl";
}
function isI18nMeta(x) {
  if (!isPlainObject(x) || !("code" in x) || !("name" in x) || !("rtl" in x)) return false;
  return isLanguageCode(x.code) && typeof x.name === "string" && typeof x.rtl === "boolean";
}
function emptySections() {
  return {
    keywords: {},
    shapes: {},
    tags: {},
    categories: {},
    capabilities: {},
    annotations: {},
    sigils: {},
    effects: {},
    types: {},
    units: {},
    literals: {},
    reservedEvents: {},
    orb: {}
  };
}
function parseI18nTables(raw, source) {
  if (!isRawI18nTable(raw)) {
    throw new Error(`i18n table "${source}": expected a JSON object, got ${typeof raw}`);
  }
  if (!isI18nMeta(raw.meta)) {
    throw new Error(`i18n table "${source}": missing or malformed "meta" (expected { code, name, rtl })`);
  }
  const badSections = [];
  const sections = emptySections();
  for (const section of I18N_SECTIONS) {
    const value = raw[section];
    if (value === void 0) continue;
    if (!isStringRecord(value)) {
      badSections.push(section);
      continue;
    }
    sections[section] = value;
  }
  if (badSections.length > 0) {
    throw new Error(`i18n table "${source}": sections not Record<string,string>: ${badSections.join(", ")}`);
  }
  return { meta: raw.meta, ...sections };
}
function parseNotationKeys(raw, source) {
  if (!isPlainObject(raw) || !("keys" in raw) || !Array.isArray(raw.keys)) {
    throw new Error(`notation file "${source}": expected { keys: string[] }`);
  }
  const keys = [];
  for (const key of raw.keys) {
    if (typeof key !== "string") {
      throw new Error(`notation file "${source}": every key must be a string`);
    }
    keys.push(key);
  }
  return keys;
}
function parseOperatorTables(raw, source) {
  if (!isPlainObject(raw) || !("operators" in raw) || !isStringRecord(raw.operators)) {
    throw new Error(`operator table "${source}": expected { operators: Record<string,string> }`);
  }
  return { operators: raw.operators };
}
var ORB_NOTATION_KEYS = new Set(
  parseNotationKeys(orb_notation_default, "orb-notation.json")
);
var coreTables = {
  en: parseI18nTables(en_default, "en.json"),
  ar: parseI18nTables(ar_default, "ar.json"),
  sl: parseI18nTables(sl_default, "sl.json")
};
function getVocabulary(lang) {
  return coreTables[lang];
}
function aliasMap(lang, section, operators) {
  let table;
  if (section === "operators") {
    if (!operators) {
      throw new Error(`aliasMap("${lang}", "operators") requires an OperatorTables argument`);
    }
    table = operators.operators;
  } else {
    table = coreTables[lang][section];
  }
  const map = /* @__PURE__ */ new Map();
  for (const [english, native] of Object.entries(table)) {
    map.set(native, english);
  }
  return map;
}
var LOLO_FIRST_TOKEN_KEYWORDS = ["app", "uses", "expects", "type", "theme", "orbital"];
function languageOfLoloFirstToken(token) {
  const matches = LANGUAGE_CODES.filter(
    (lang) => LOLO_FIRST_TOKEN_KEYWORDS.some((kw) => coreTables[lang].keywords[kw] === token)
  );
  return matches.length === 1 ? matches[0] : void 0;
}
function languageOfOrbTopLevelKeys(keys) {
  const keySet = new Set(keys);
  const matches = LANGUAGE_CODES.filter((lang) => keySet.has(coreTables[lang].orb.orbitals));
  return matches.length === 1 ? matches[0] : void 0;
}
function checkI18nCoverage(input) {
  const problems = [];
  const { core, std, canonicalOperators } = input;
  const enTable = core.en;
  for (const lang of LANGUAGE_CODES) {
    for (const key of Object.keys(core[lang].orb)) {
      if (ORB_NOTATION_KEYS.has(key)) {
        problems.push({
          lang,
          section: "orb",
          kind: "notation-in-vocabulary",
          key,
          detail: "design-system token name \u2014 notation, not language vocabulary"
        });
      }
    }
  }
  for (const lang of LANGUAGE_CODES) {
    const table = core[lang];
    for (const section of I18N_SECTIONS) {
      const values = table[section];
      if (lang !== "en") {
        const enKeys = new Set(Object.keys(enTable[section]));
        const langKeys = new Set(Object.keys(values));
        for (const key of enKeys) {
          if (!langKeys.has(key)) {
            problems.push({ lang, section, kind: "missing", key });
          }
        }
        for (const key of langKeys) {
          if (!enKeys.has(key)) {
            problems.push({ lang, section, kind: "orphan", key });
          }
        }
      }
      for (const [key, value] of Object.entries(values)) {
        if (value === "") {
          problems.push({ lang, section, kind: "empty", key });
        }
      }
    }
  }
  for (const lang of LANGUAGE_CODES) {
    const table = core[lang];
    const occurrences = /* @__PURE__ */ new Map();
    for (const section of I18N_SECTIONS) {
      for (const [key, value] of Object.entries(table[section])) {
        const list = occurrences.get(key) ?? [];
        list.push({ section, value });
        occurrences.set(key, list);
      }
    }
    const opTable = std?.[lang]?.operators;
    if (opTable) {
      for (const [key, value] of Object.entries(opTable)) {
        const list = occurrences.get(key) ?? [];
        list.push({ section: "operators", value });
        occurrences.set(key, list);
      }
    }
    for (const [key, entries] of occurrences) {
      if (entries.length < 2) continue;
      const baseline = entries[0];
      for (let i = 1; i < entries.length; i++) {
        const entry = entries[i];
        if (entry.value !== baseline.value) {
          problems.push({
            lang,
            section: entry.section,
            kind: "inconsistent",
            key,
            detail: `"${key}" is "${baseline.value}" in ${baseline.section} but "${entry.value}" in ${entry.section}`
          });
        }
      }
    }
  }
  for (const lang of LANGUAGE_CODES) {
    const table = core[lang];
    for (const section of I18N_SECTIONS) {
      const byValue = /* @__PURE__ */ new Map();
      for (const [key, value] of Object.entries(table[section])) {
        const keys = byValue.get(value) ?? [];
        keys.push(key);
        byValue.set(value, keys);
      }
      for (const [value, keys] of byValue) {
        if (keys.length < 2) continue;
        for (let i = 1; i < keys.length; i++) {
          problems.push({
            lang,
            section,
            kind: "collision",
            key: keys[i],
            detail: `shares native value "${value}" with "${keys[0]}" in ${section}`
          });
        }
      }
    }
    const combined = /* @__PURE__ */ new Map();
    for (const [key, value] of Object.entries(table.effects)) {
      const list = combined.get(value) ?? [];
      list.push({ section: "effects", key });
      combined.set(value, list);
    }
    const opTable = std?.[lang]?.operators;
    if (opTable) {
      for (const [key, value] of Object.entries(opTable)) {
        const list = combined.get(value) ?? [];
        list.push({ section: "operators", key });
        combined.set(value, list);
      }
    }
    for (const [value, entries] of combined) {
      const hasEffects = entries.some((e) => e.section === "effects");
      const hasOperators = entries.some((e) => e.section === "operators");
      if (!(hasEffects && hasOperators)) continue;
      const first = entries[0];
      for (const entry of entries.slice(1)) {
        if (entry.key === first.key) continue;
        problems.push({
          lang,
          section: "effects\u222Aoperators",
          kind: "collision",
          key: entry.key,
          detail: `shares native value "${value}" with "${first.key}" (${first.section}) in effects\u222Aoperators`
        });
      }
    }
  }
  const selectorUses = /* @__PURE__ */ new Map();
  for (const lang of LANGUAGE_CODES) {
    const table = core[lang];
    const selectors = [
      ...LOLO_FIRST_TOKEN_KEYWORDS.map((key) => ({ section: "keywords", key, value: table.keywords[key] })),
      { section: "orb", key: "orbitals", value: table.orb.orbitals }
    ];
    for (const { section, key, value } of selectors) {
      if (value === void 0) continue;
      const uses = selectorUses.get(value) ?? [];
      uses.push({ lang, section, key });
      selectorUses.set(value, uses);
    }
  }
  for (const [value, uses] of selectorUses) {
    const langs = new Set(uses.map((u) => u.lang));
    if (langs.size < 2) continue;
    for (const use of uses) {
      const others = uses.filter((u) => u.lang !== use.lang).map((u) => `${u.lang}:${u.section}.${u.key}`);
      problems.push({
        lang: use.lang,
        section: use.section,
        kind: "selector-not-unique",
        key: use.key,
        detail: `${use.section}.${use.key} = "${value}" is also a language selector in: ${others.join(", ")}`
      });
    }
  }
  if (std && canonicalOperators) {
    const canonicalSet = new Set(canonicalOperators);
    for (const lang of LANGUAGE_CODES) {
      const opTable = std[lang]?.operators;
      if (!opTable) continue;
      const langKeys = new Set(Object.keys(opTable));
      for (const op of canonicalSet) {
        if (!langKeys.has(op)) {
          problems.push({ lang, section: "operators", kind: "operators-mismatch", key: op, detail: "missing from language operator table" });
        }
      }
      for (const op of langKeys) {
        if (!canonicalSet.has(op)) {
          problems.push({ lang, section: "operators", kind: "operators-mismatch", key: op, detail: "not present in canonical operator set" });
        }
      }
    }
  }
  return { ok: problems.length === 0, problems };
}
function reportIdenticalToEnglish(input) {
  const problems = [];
  const enTable = input.core.en;
  for (const lang of LANGUAGE_CODES) {
    if (lang === "en") continue;
    const table = input.core[lang];
    for (const section of I18N_SECTIONS) {
      for (const [key, value] of Object.entries(table[section])) {
        const enValue = enTable[section][key];
        if (enValue !== void 0 && value === enValue) {
          problems.push({ lang, section, kind: "identical-to-english", key, detail: `matches English value "${enValue}"` });
        }
      }
    }
  }
  return problems;
}

export { I18N_SECTIONS, LANGUAGE_CODES, LOLO_FIRST_TOKEN_KEYWORDS, ORB_NOTATION_KEYS, aliasMap, checkI18nCoverage, coreTables, getVocabulary, languageOfLoloFirstToken, languageOfOrbTopLevelKeys, lexLolo, localizeLoloSource, localizeMap, localizeOrbValue, parseI18nTables, parseOperatorTables, reportIdenticalToEnglish };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map